import { Component, computed, inject, input, OnInit } from '@angular/core';
import { AuthService } from 'src/app/features/auth/auth.service';
import { TRANSLATE_IMPORTS } from 'src/app/features/i18n/translate-imports';
import { ChatNames } from 'src/app/features/stories/types/Chat';
import { aiChatTitleKey } from 'src/app/features/stories/utils/aiChatTitle';
import { IonTitle, IonNote } from '@ionic/angular/standalone';

@Component({
  selector: 're-chat-title',
  imports: [IonNote, IonTitle, ...TRANSLATE_IMPORTS],
  templateUrl: './chat-title.component.html',
  styleUrls: ['./chat-title.component.scss'],
})
export class ChatTitleComponent {
  auth = inject(AuthService);
  chat = input.required<ChatNames | undefined>();
  name = computed(() => {
    if (this.chat()?.story) return this.chat()?.name;
    if (this.chat()?.friendship) {
      return this.chat()?.friendship?.user1?.id ===
        this.auth.profileSignal()?.id
        ? this.chat()?.friendship?.user2?.displayName
        : this.chat()?.friendship?.user1?.displayName;
    }
    return this.chat()?.name ?? '';
  });
  titleKey = computed(() => aiChatTitleKey(this.chat()?.kind));
  storyName = computed(() => {
    if (this.chat()?.story) return this.chat()?.story?.name;
    return '';
  });
}
